import NativeStorage from "./native";

export default new NativeStorage("localStorage");
